import { AsyncSearch } from '@global-engineering-shared/gweb-material-global';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import SearchOption from 'components/SearchBar/SearchOption';
import { IFormattedSearch } from 'components/SearchBar/SearchOption/types/IFormattedSearch';
import { handleShowAllSearchResults } from 'components/SearchBar/utils/handleShowAllSearchResults';
import { PageResponse } from 'context/PaginatedItems/types/PaginatedItems';
import { getEntityPageUrl } from 'features/Entity/utils/getEntityPageUrl';
import useFetchData from 'hooks/useFetchData';
import { ILiveEntity } from 'types/detailsEntityType';
import { ENTITY_SEARCH_API_URL, SEARCH_RESULTS_LIMIT } from 'utils/defaults';

const SearchBar = () => {
  const [inputValue, setInputValue] = useState('');
  const [searchResults, setSearchResults] = useState<ILiveEntity[]>([]);
  const navigate = useNavigate();
  const { getData, isDataLoading } = useFetchData();

  const loadItemsAndDispatch = async (url: string) => {
    await getData<PageResponse<ILiveEntity>>(url, (pageResponse) => {
      setSearchResults(pageResponse.items);
    });
  };

  const handleSearch = (oldValue: string, newValue: string) => {
    if (newValue !== oldValue) {
      setInputValue(newValue);
    }
  };

  useEffect(() => {
    if (inputValue) {
      const url = `${ENTITY_SEARCH_API_URL}?searchTerm=${inputValue}&page=1&pageSize=${SEARCH_RESULTS_LIMIT}`;
      loadItemsAndDispatch(url);
    }
  }, [inputValue]);

  return (
    <div>
      <AsyncSearch
        searchTerm=""
        searchedData={searchResults}
        SearchOption={(props) => <SearchOption {...props} />}
        setSearchTerm={() => ''}
        placeholder="Search IDs or Names"
        handleSearch={(newValue) => handleSearch(inputValue, newValue)}
        handleSelection={(option: IFormattedSearch) =>
          navigate(`${getEntityPageUrl(option.entityType)}/${option.spaceId}`)
        }
        searching={isDataLoading}
        searchResultsLimit={SEARCH_RESULTS_LIMIT}
        debounceTime={350}
        noResultsText={`No results found for "${inputValue}"`}
        showAllSearchResults={() => handleShowAllSearchResults(navigate, inputValue, searchResults)}
      />
    </div>
  );
};

export default SearchBar;
